// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .home_article_card_skeleton_container {
    display: none !important;
  }

  .home_slot_card_container {
    display: none !important;
  }
  .home_page_videos_thumbnail {
    width: 100% !important;

    object-fit: cover;
    border-radius: 10px;
  }
  .home_page_videos_text_content {
    color: #fff;
    font-size: large;
  }
  .home_page_videos_thumbnail_div {
    width: 100%;
  }
  .home_videos_second_column_contents {
    width: 90%;
    display: grid;
    justify-content: center;
    grid-template-columns: 50% 50%;
  }
  .home_videos_second_column_image {
    width: 95%;
    border: 1.5px solid rgb(231, 231, 231);
    border-radius: 10px;
    object-fit: "cover";
  }
  .home_videos_viewed_count_and_published_div {
    display: flex;
    align-items: flex-start;
  }
  .home_videos_section_mobile_view {
    display: none !important;
  }
  .become_member_content {
    font-size: 15px !important;
  }
  .become_member_content_ta {
    font-size: 15px !important;
  }
  .home_user_contribution_two_image_box {
    width: 200px !important;
    height: 134px !important;
  }

  .exposing_fake_news_container {
    display: none;
  }

  .exposing_fake_news_mobile_view_title {
    font-size: 15px !important;
    font-weight: 700;
  }
  .exposing_fake_news_divider_container {
    display: none;
  }
  .exposing_fake_news_first_column_details_mobile_view {
    height: 105px;
  }
  .exposing_fake_news_first_column_writer_name_and_views {
    font-size: 12px;
  }
  .exposing_fake_news_first_column_button {
    height: 25px;
    font-size: 11px;
  }

  .home_article_row_wrapper {
    flex-direction: column;
    align-items: center;
    height: auto !important;
    gap: 20px;
  }

  .home_article_row_container {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .user_contributed_story_column_container {
    border-radius: 0px !important;
  }
  .user_contributed_story_column_box {
    gap: 20px;
  }
  .home_videos_subscribe_button {
    background-color: #ef1d26;
    color: #fff;
    border-radius: 10px;
    width: 50%;
    height: 40px;
    align-items: center;
    justify-content: space-around;
    display: flex;
    margin-bottom: 20px;
  }
  .home_awards_card_image_overlay_text {
    font-family: "Lato";
    font-size: medium;
  }

  .home_article_trending_container {
    width: 100%;
    gap: 10px;
  }


  .home_trending_title_text {
    font-size: 22px !important;
  }

  .home_article_second_column_writer_name_and_views {
    font-size: 12px;
  }

  .home_article_second_column_details {
    width: 90% !important;
    height: 100px;
  }
  .home_article_sec_column_inner_row_content {
    margin-bottom: 20px;
  }

  .slots_card_wrapper {
    display: none;
  }
  .home_carousel_card {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: "5px";
    padding: 2%;
  }
  .home_logo_and_container {
    display: none;
  }
  .slot_card_title {
    font-size: 20px !important;
  }
  .slot_card_title_en {
    font-size: 18px !important;
  }
  .home_carousel_card {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: "5px";
    padding: 2%;
  }
  .home_logo_and_container {
    display: none;
  }
  .exposing_fake_news_mobile_view_author_name {
    font-size: 14px !important;
  }
  .home_donation_wrapper {
    flex-direction: column;
  }
  .home_donation_first_column_container {
    width: 100%;
  }
  .donation_fight_against_text {
    font-size: 49px !important;
  }
  .donation_hash_text {
    font-size: 60px !important;
  }

  .home_donation_third_column_wrapper {
    width: 95%;
    justify-content: space-between;
  }
  .home_donate_button {
    width: 95%;
    height: 38px;
    font-size: 15px;
  }

  .home_donatio_content {
    font-size: 20px;
  }

  .badge_default {
    height: 50px;
    width: 100px;
    font-size: 15px;
  }
  .badge_selected {
    height: 50px;
    width: 100px;
    font-size: 15px;
  }

  .home_donate_button {
    width: 90%;
    height: 30px;
    font-size: 15px;
  }
  .featured_fact_check_button {
    font-size: 11px;
  }
  .home_videos_second_column_overlay_play_button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .user_contribution_mobile_card_container {
    width: 250px;
    border-radius: 10px !important;
    box-shadow: var(--border-shadow);
    height: 280px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }
  .home_donation_third_column_container {
    justify-content: center;
    height: 200px;
    width: 100%;
  }
  .home_donation_fourth_column_container {
    height: 88px;
    width: 100%;
  }

  .home_donate_button {
    width: 95%;
    height: 38px;
    font-size: 15px;
  }
  .home_donatio_content {
    font-size: 20px;
  }

  .badge_default {
    height: 50px;
    width: 100px;
    font-size: 15px;
  }
  .badge_selected {
    height: 50px;
    width: 100px;
    font-size: 15px;
  }

  .donate_amt_content_text {
    font-size: 25px;
  }
  .donate_inr_text {
    font-size: 20px;
  }
  .home_donate_button_disabled {
    width: 95%;
    height: 38px;
    font-size: 15px;
  }

  .home_article_first_card_container {
    display: none !important;
  }
  .home_article_first_column_wrapper {
    display: flex;
    flex-direction: column !important;
  }
  .home_article_second_column {
    margin-top: 10px;
    width: 100%;
  }
  .home_article_title_text {
    font-size: 30px;
    font-weight: bold;
  }
  .home_article_title {
    font-size: 15px;
  }

  .continue_reading_text {
    font-size: 12px;
  }
  .continue_reading_text_ta {
    font-size: 12px;
  }
  .home_user_contributed_story_first_column_main_container {
    display: none;
  }
  .home_trending_author_text {
    font-size: 13px;
  }
  .exposing_fake_news_second_section {
    display: none !important;
  }
  .quick_access_language_container {
    width: 115px !important;
  }

  .recent_fact_check_title_text {
    font-size: 21px !important;
    line-height: 31px !important;
  }
  .fact_trending_image {
    height: 190px;
  }
  .home_donation_first_column_wrapper {
    padding-top: 30px;
  }
  .see_all_btn {
    font-size: 12px !important;
  }
  .home_videos_title_text_ta {
    font-size: 25px;
    font-family: "Kufam";
    font-weight: 600;
  }
  .home_page_videos_text_content_ta {
    font-size: 12px !important;
  }
  .home_slots_background_container {
    display: none !important;
  }
  .home_donation_input {
    width: 75% !important;
  }
  .home_donation_second_column_container {
    width: 100%;
  }
  .top_contribute_title_ta {
    font-size: 12px;
  }
  .home_donation_third_column_division {
    width: 95%;
    justify-content: space-between;
  }
  .home_amount_container_ta {
    display: flex;
    flex-direction: row;
    gap: 25px;
    align-items: center;
  }
  .home_amount_container {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }
  .app-download-icon{
    width: 12%;
        height: 8%;
        position: fixed;
        left: 10px;
        bottom: 75px;
        background-color: #0065cc;
        border-radius: 50%;
        z-index: 99;
        cursor: pointer;
        border: 1px solid #0065cc;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_768_1023/screen_768_1023_home.css"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;;IAEtB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,UAAU;IACV,sCAAsC;IACtC,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,SAAS;EACX;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;;EAGA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,8BAA8B;IAC9B,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,aAAa;IACb,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,iCAAiC;EACnC;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,UAAU;QACN,UAAU;QACV,eAAe;QACf,UAAU;QACV,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,yBAAyB;EAC/B;AACF","sourcesContent":["@media only screen and (min-width: 768px) and (max-width: 1023px) {\n  .home_article_card_skeleton_container {\n    display: none !important;\n  }\n\n  .home_slot_card_container {\n    display: none !important;\n  }\n  .home_page_videos_thumbnail {\n    width: 100% !important;\n\n    object-fit: cover;\n    border-radius: 10px;\n  }\n  .home_page_videos_text_content {\n    color: #fff;\n    font-size: large;\n  }\n  .home_page_videos_thumbnail_div {\n    width: 100%;\n  }\n  .home_videos_second_column_contents {\n    width: 90%;\n    display: grid;\n    justify-content: center;\n    grid-template-columns: 50% 50%;\n  }\n  .home_videos_second_column_image {\n    width: 95%;\n    border: 1.5px solid rgb(231, 231, 231);\n    border-radius: 10px;\n    object-fit: \"cover\";\n  }\n  .home_videos_viewed_count_and_published_div {\n    display: flex;\n    align-items: flex-start;\n  }\n  .home_videos_section_mobile_view {\n    display: none !important;\n  }\n  .become_member_content {\n    font-size: 15px !important;\n  }\n  .become_member_content_ta {\n    font-size: 15px !important;\n  }\n  .home_user_contribution_two_image_box {\n    width: 200px !important;\n    height: 134px !important;\n  }\n\n  .exposing_fake_news_container {\n    display: none;\n  }\n\n  .exposing_fake_news_mobile_view_title {\n    font-size: 15px !important;\n    font-weight: 700;\n  }\n  .exposing_fake_news_divider_container {\n    display: none;\n  }\n  .exposing_fake_news_first_column_details_mobile_view {\n    height: 105px;\n  }\n  .exposing_fake_news_first_column_writer_name_and_views {\n    font-size: 12px;\n  }\n  .exposing_fake_news_first_column_button {\n    height: 25px;\n    font-size: 11px;\n  }\n\n  .home_article_row_wrapper {\n    flex-direction: column;\n    align-items: center;\n    height: auto !important;\n    gap: 20px;\n  }\n\n  .home_article_row_container {\n    margin-top: 20px;\n    margin-bottom: 10px;\n  }\n  .user_contributed_story_column_container {\n    border-radius: 0px !important;\n  }\n  .user_contributed_story_column_box {\n    gap: 20px;\n  }\n  .home_videos_subscribe_button {\n    background-color: #ef1d26;\n    color: #fff;\n    border-radius: 10px;\n    width: 50%;\n    height: 40px;\n    align-items: center;\n    justify-content: space-around;\n    display: flex;\n    margin-bottom: 20px;\n  }\n  .home_awards_card_image_overlay_text {\n    font-family: \"Lato\";\n    font-size: medium;\n  }\n\n  .home_article_trending_container {\n    width: 100%;\n    gap: 10px;\n  }\n\n\n  .home_trending_title_text {\n    font-size: 22px !important;\n  }\n\n  .home_article_second_column_writer_name_and_views {\n    font-size: 12px;\n  }\n\n  .home_article_second_column_details {\n    width: 90% !important;\n    height: 100px;\n  }\n  .home_article_sec_column_inner_row_content {\n    margin-bottom: 20px;\n  }\n\n  .slots_card_wrapper {\n    display: none;\n  }\n  .home_carousel_card {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: \"5px\";\n    padding: 2%;\n  }\n  .home_logo_and_container {\n    display: none;\n  }\n  .slot_card_title {\n    font-size: 20px !important;\n  }\n  .slot_card_title_en {\n    font-size: 18px !important;\n  }\n  .home_carousel_card {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: \"5px\";\n    padding: 2%;\n  }\n  .home_logo_and_container {\n    display: none;\n  }\n  .exposing_fake_news_mobile_view_author_name {\n    font-size: 14px !important;\n  }\n  .home_donation_wrapper {\n    flex-direction: column;\n  }\n  .home_donation_first_column_container {\n    width: 100%;\n  }\n  .donation_fight_against_text {\n    font-size: 49px !important;\n  }\n  .donation_hash_text {\n    font-size: 60px !important;\n  }\n\n  .home_donation_third_column_wrapper {\n    width: 95%;\n    justify-content: space-between;\n  }\n  .home_donate_button {\n    width: 95%;\n    height: 38px;\n    font-size: 15px;\n  }\n\n  .home_donatio_content {\n    font-size: 20px;\n  }\n\n  .badge_default {\n    height: 50px;\n    width: 100px;\n    font-size: 15px;\n  }\n  .badge_selected {\n    height: 50px;\n    width: 100px;\n    font-size: 15px;\n  }\n\n  .home_donate_button {\n    width: 90%;\n    height: 30px;\n    font-size: 15px;\n  }\n  .featured_fact_check_button {\n    font-size: 11px;\n  }\n  .home_videos_second_column_overlay_play_button {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .user_contribution_mobile_card_container {\n    width: 250px;\n    border-radius: 10px !important;\n    box-shadow: var(--border-shadow);\n    height: 280px;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n  }\n  .home_donation_third_column_container {\n    justify-content: center;\n    height: 200px;\n    width: 100%;\n  }\n  .home_donation_fourth_column_container {\n    height: 88px;\n    width: 100%;\n  }\n\n  .home_donate_button {\n    width: 95%;\n    height: 38px;\n    font-size: 15px;\n  }\n  .home_donatio_content {\n    font-size: 20px;\n  }\n\n  .badge_default {\n    height: 50px;\n    width: 100px;\n    font-size: 15px;\n  }\n  .badge_selected {\n    height: 50px;\n    width: 100px;\n    font-size: 15px;\n  }\n\n  .donate_amt_content_text {\n    font-size: 25px;\n  }\n  .donate_inr_text {\n    font-size: 20px;\n  }\n  .home_donate_button_disabled {\n    width: 95%;\n    height: 38px;\n    font-size: 15px;\n  }\n\n  .home_article_first_card_container {\n    display: none !important;\n  }\n  .home_article_first_column_wrapper {\n    display: flex;\n    flex-direction: column !important;\n  }\n  .home_article_second_column {\n    margin-top: 10px;\n    width: 100%;\n  }\n  .home_article_title_text {\n    font-size: 30px;\n    font-weight: bold;\n  }\n  .home_article_title {\n    font-size: 15px;\n  }\n\n  .continue_reading_text {\n    font-size: 12px;\n  }\n  .continue_reading_text_ta {\n    font-size: 12px;\n  }\n  .home_user_contributed_story_first_column_main_container {\n    display: none;\n  }\n  .home_trending_author_text {\n    font-size: 13px;\n  }\n  .exposing_fake_news_second_section {\n    display: none !important;\n  }\n  .quick_access_language_container {\n    width: 115px !important;\n  }\n\n  .recent_fact_check_title_text {\n    font-size: 21px !important;\n    line-height: 31px !important;\n  }\n  .fact_trending_image {\n    height: 190px;\n  }\n  .home_donation_first_column_wrapper {\n    padding-top: 30px;\n  }\n  .see_all_btn {\n    font-size: 12px !important;\n  }\n  .home_videos_title_text_ta {\n    font-size: 25px;\n    font-family: \"Kufam\";\n    font-weight: 600;\n  }\n  .home_page_videos_text_content_ta {\n    font-size: 12px !important;\n  }\n  .home_slots_background_container {\n    display: none !important;\n  }\n  .home_donation_input {\n    width: 75% !important;\n  }\n  .home_donation_second_column_container {\n    width: 100%;\n  }\n  .top_contribute_title_ta {\n    font-size: 12px;\n  }\n  .home_donation_third_column_division {\n    width: 95%;\n    justify-content: space-between;\n  }\n  .home_amount_container_ta {\n    display: flex;\n    flex-direction: row;\n    gap: 25px;\n    align-items: center;\n  }\n  .home_amount_container {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n  }\n  .app-download-icon{\n    width: 12%;\n        height: 8%;\n        position: fixed;\n        left: 10px;\n        bottom: 75px;\n        background-color: #0065cc;\n        border-radius: 50%;\n        z-index: 99;\n        cursor: pointer;\n        border: 1px solid #0065cc;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
